import { render, staticRenderFns } from "./KnowledgeTestList.vue?vue&type=template&id=1e0c95f4&"
import script from "./KnowledgeTestList.vue?vue&type=script&lang=js&"
export * from "./KnowledgeTestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports